/**
 * TanStack Query Client Configuration
 *
 * Centralized QueryClient with optimized defaults for MeBi mobile app.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes before considered stale
      staleTime: 5 * 60 * 1000,
      // Keep unused data in cache for 30 minutes
      gcTime: 30 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Don't refetch when window regains focus (mobile app behavior)
      refetchOnWindowFocus: false,
      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

// Query Keys - centralized for consistent invalidation
export const queryKeys = {
  auth: {
    all: ["auth"] as const,
    session: () => [...queryKeys.auth.all, "session"] as const,
    user: () => [...queryKeys.auth.all, "user"] as const,
    profile: (userId: string) =>
      [...queryKeys.auth.all, "profile", userId] as const,
  },
  profile: {
    all: ["profile"] as const,
    user: (userId: string) =>
      [...queryKeys.profile.all, "user", userId] as const,
    player: (userId: string) =>
      [...queryKeys.profile.all, "player", userId] as const,
    organizer: (userId: string) =>
      [...queryKeys.profile.all, "organizer", userId] as const,
  },
  tournaments: {
    all: ["tournaments"] as const,
    list: (filters?: object) =>
      [...queryKeys.tournaments.all, "list", filters] as const,
    detail: (id: string) =>
      [...queryKeys.tournaments.all, "detail", id] as const,
  },
};

export default queryClient;
